import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModuleState } from '@store/reducers';

export const selectModuleState = createFeatureSelector<ModuleState>('module');

export const selectModuleLoading = createSelector(
  selectModuleState,
  (state) => state.loading
);

export const selectModuleList = createSelector(
  selectModuleState,
  (state) => state.moduleList
);

export const selectModuleError = createSelector(
  selectModuleState,
  (state) => state.error
);

export const selectModuleEditMode = createSelector(
  selectModuleState,
  (state) => state.editMode
);

export const selectModuleIsEditing = createSelector(
  selectModuleState,
  (state) => state.isEditing
);

export const selectModuleForm = createSelector(
  selectModuleState,
  (state) => state.moduleForm
);

export const selectModuleId = createSelector(
  selectModuleState,
  (state) => state.moduleId
);

export const selectModule = createSelector(
  selectModuleState,
  (state) => state.module
);
